module.exports = __webpack_public_path__ + "img/slash-circle-fill.13e2c9b6.svg";